// Lista completa de países con banderas y códigos telefónicos
export const countries = [
  { code: "AD", name: "Andorra", flag: "🇦🇩", phoneCode: "+376" },
  { code: "AE", name: "Emiratos Árabes Unidos", flag: "🇦🇪", phoneCode: "+971" },
  { code: "AF", name: "Afganistán", flag: "🇦🇫", phoneCode: "+93" },
  { code: "AG", name: "Antigua y Barbuda", flag: "🇦🇬", phoneCode: "+1268" },
  { code: "AI", name: "Anguila", flag: "🇦🇮", phoneCode: "+1264" },
  { code: "AL", name: "Albania", flag: "🇦🇱", phoneCode: "+355" },
  { code: "AM", name: "Armenia", flag: "🇦🇲", phoneCode: "+374" },
  { code: "AO", name: "Angola", flag: "🇦🇴", phoneCode: "+244" },
  { code: "AQ", name: "Antártida", flag: "🇦🇶", phoneCode: "+672" },
  { code: "AR", name: "Argentina", flag: "🇦🇷", phoneCode: "+54" },
  { code: "AS", name: "Samoa Americana", flag: "🇦🇸", phoneCode: "+1684" },
  { code: "AT", name: "Austria", flag: "🇦🇹", phoneCode: "+43" },
  { code: "AU", name: "Australia", flag: "🇦🇺", phoneCode: "+61" },
  { code: "AW", name: "Aruba", flag: "🇦🇼", phoneCode: "+297" },
  { code: "AX", name: "Islas Åland", flag: "🇦🇽", phoneCode: "+358" },
  { code: "AZ", name: "Azerbaiyán", flag: "🇦🇿", phoneCode: "+994" },
  { code: "BA", name: "Bosnia y Herzegovina", flag: "🇧🇦", phoneCode: "+387" },
  { code: "BB", name: "Barbados", flag: "🇧🇧", phoneCode: "+1246" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩", phoneCode: "+880" },
  { code: "BE", name: "Bélgica", flag: "🇧🇪", phoneCode: "+32" },
  { code: "BF", name: "Burkina Faso", flag: "🇧🇫", phoneCode: "+226" },
  { code: "BG", name: "Bulgaria", flag: "🇧🇬", phoneCode: "+359" },
  { code: "BH", name: "Baréin", flag: "🇧🇭", phoneCode: "+973" },
  { code: "BI", name: "Burundi", flag: "🇧🇮", phoneCode: "+257" },
  { code: "BJ", name: "Benín", flag: "🇧🇯", phoneCode: "+229" },
  { code: "BL", name: "San Bartolomé", flag: "🇧🇱", phoneCode: "+590" },
  { code: "BM", name: "Bermudas", flag: "🇧🇲", phoneCode: "+1441" },
  { code: "BN", name: "Brunéi", flag: "🇧🇳", phoneCode: "+673" },
  { code: "BO", name: "Bolivia", flag: "🇧🇴", phoneCode: "+591" },
  { code: "BQ", name: "Bonaire", flag: "🇧🇶", phoneCode: "+599" },
  { code: "BR", name: "Brasil", flag: "🇧🇷", phoneCode: "+55" },
  { code: "BS", name: "Bahamas", flag: "🇧🇸", phoneCode: "+1242" },
  { code: "BT", name: "Bután", flag: "🇧🇹", phoneCode: "+975" },
  { code: "BV", name: "Isla Bouvet", flag: "🇧🇻", phoneCode: "+47" },
  { code: "BW", name: "Botsuana", flag: "🇧🇼", phoneCode: "+267" },
  { code: "BY", name: "Bielorrusia", flag: "🇧🇾", phoneCode: "+375" },
  { code: "BZ", name: "Belice", flag: "🇧🇿", phoneCode: "+501" },
  { code: "CA", name: "Canadá", flag: "🇨🇦", phoneCode: "+1" },
  { code: "CC", name: "Islas Cocos", flag: "🇨🇨", phoneCode: "+61" },
  { code: "CD", name: "República Democrática del Congo", flag: "🇨🇩", phoneCode: "+243" },
  { code: "CF", name: "República Centroafricana", flag: "🇨🇫", phoneCode: "+236" },
  { code: "CG", name: "República del Congo", flag: "🇨🇬", phoneCode: "+242" },
  { code: "CH", name: "Suiza", flag: "🇨🇭", phoneCode: "+41" },
  { code: "CI", name: "Costa de Marfil", flag: "🇨🇮", phoneCode: "+225" },
  { code: "CK", name: "Islas Cook", flag: "🇨🇰", phoneCode: "+682" },
  { code: "CL", name: "Chile", flag: "🇨🇱", phoneCode: "+56" },
  { code: "CM", name: "Camerún", flag: "🇨🇲", phoneCode: "+237" },
  { code: "CN", name: "China", flag: "🇨🇳", phoneCode: "+86" },
  { code: "CO", name: "Colombia", flag: "🇨🇴", phoneCode: "+57" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷", phoneCode: "+506" },
  { code: "CU", name: "Cuba", flag: "🇨🇺", phoneCode: "+53" },
  { code: "CV", name: "Cabo Verde", flag: "🇨🇻", phoneCode: "+238" },
  { code: "CW", name: "Curazao", flag: "🇨🇼", phoneCode: "+599" },
  { code: "CX", name: "Isla de Navidad", flag: "🇨🇽", phoneCode: "+61" },
  { code: "CY", name: "Chipre", flag: "🇨🇾", phoneCode: "+357" },
  { code: "CZ", name: "República Checa", flag: "🇨🇿", phoneCode: "+420" },
  { code: "DE", name: "Alemania", flag: "🇩🇪", phoneCode: "+49" },
  { code: "DJ", name: "Yibuti", flag: "🇩🇯", phoneCode: "+253" },
  { code: "DK", name: "Dinamarca", flag: "🇩🇰", phoneCode: "+45" },
  { code: "DM", name: "Dominica", flag: "🇩🇲", phoneCode: "+1767" },
  { code: "DO", name: "República Dominicana", flag: "🇩🇴", phoneCode: "+1809" },
  { code: "DZ", name: "Argelia", flag: "🇩🇿", phoneCode: "+213" },
  { code: "EC", name: "Ecuador", flag: "🇪🇨", phoneCode: "+593" },
  { code: "EE", name: "Estonia", flag: "🇪🇪", phoneCode: "+372" },
  { code: "EG", name: "Egipto", flag: "🇪🇬", phoneCode: "+20" },
  { code: "EH", name: "Sahara Occidental", flag: "🇪🇭", phoneCode: "+212" },
  { code: "ER", name: "Eritrea", flag: "🇪🇷", phoneCode: "+291" },
  { code: "ES", name: "España", flag: "🇪🇸", phoneCode: "+34" },
  { code: "ET", name: "Etiopía", flag: "🇪🇹", phoneCode: "+251" },
  { code: "FI", name: "Finlandia", flag: "🇫🇮", phoneCode: "+358" },
  { code: "FJ", name: "Fiyi", flag: "🇫🇯", phoneCode: "+679" },
  { code: "FK", name: "Islas Malvinas", flag: "🇫🇰", phoneCode: "+500" },
  { code: "FM", name: "Micronesia", flag: "🇫🇲", phoneCode: "+691" },
  { code: "FO", name: "Islas Feroe", flag: "🇫🇴", phoneCode: "+298" },
  { code: "FR", name: "Francia", flag: "🇫🇷", phoneCode: "+33" },
  { code: "GA", name: "Gabón", flag: "🇬🇦", phoneCode: "+241" },
  { code: "GB", name: "Reino Unido", flag: "🇬🇧", phoneCode: "+44" },
  { code: "GD", name: "Granada", flag: "🇬🇩", phoneCode: "+1473" },
  { code: "GE", name: "Georgia", flag: "🇬🇪", phoneCode: "+995" },
  { code: "GF", name: "Guayana Francesa", flag: "🇬🇫", phoneCode: "+594" },
  { code: "GG", name: "Guernsey", flag: "🇬🇬", phoneCode: "+44" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", phoneCode: "+233" },
  { code: "GI", name: "Gibraltar", flag: "🇬🇮", phoneCode: "+350" },
  { code: "GL", name: "Groenlandia", flag: "🇬🇱", phoneCode: "+299" },
  { code: "GM", name: "Gambia", flag: "🇬🇲", phoneCode: "+220" },
  { code: "GN", name: "Guinea", flag: "🇬🇳", phoneCode: "+224" },
  { code: "GP", name: "Guadalupe", flag: "🇬🇵", phoneCode: "+590" },
  { code: "GQ", name: "Guinea Ecuatorial", flag: "🇬🇶", phoneCode: "+240" },
  { code: "GR", name: "Grecia", flag: "🇬🇷", phoneCode: "+30" },
  { code: "GS", name: "Islas Georgias del Sur", flag: "🇬🇸", phoneCode: "+500" },
  { code: "GT", name: "Guatemala", flag: "🇬🇹", phoneCode: "+502" },
  { code: "GU", name: "Guam", flag: "🇬🇺", phoneCode: "+1671" },
  { code: "GW", name: "Guinea-Bisáu", flag: "🇬🇼", phoneCode: "+245" },
  { code: "GY", name: "Guyana", flag: "🇬🇾", phoneCode: "+592" },
  { code: "HK", name: "Hong Kong", flag: "🇭🇰", phoneCode: "+852" },
  { code: "HM", name: "Islas Heard y McDonald", flag: "🇭🇲", phoneCode: "+672" },
  { code: "HN", name: "Honduras", flag: "🇭🇳", phoneCode: "+504" },
  { code: "HR", name: "Croacia", flag: "🇭🇷", phoneCode: "+385" },
  { code: "HT", name: "Haití", flag: "🇭🇹", phoneCode: "+509" },
  { code: "HU", name: "Hungría", flag: "🇭🇺", phoneCode: "+36" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩", phoneCode: "+62" },
  { code: "IE", name: "Irlanda", flag: "🇮🇪", phoneCode: "+353" },
  { code: "IL", name: "Israel", flag: "🇮🇱", phoneCode: "+972" },
  { code: "IM", name: "Isla de Man", flag: "🇮🇲", phoneCode: "+44" },
  { code: "IN", name: "India", flag: "🇮🇳", phoneCode: "+91" },
  { code: "IO", name: "Territorio Británico del Océano Índico", flag: "🇮🇴", phoneCode: "+246" },
  { code: "IQ", name: "Irak", flag: "🇮🇶", phoneCode: "+964" },
  { code: "IR", name: "Irán", flag: "🇮🇷", phoneCode: "+98" },
  { code: "IS", name: "Islandia", flag: "🇮🇸", phoneCode: "+354" },
  { code: "IT", name: "Italia", flag: "🇮🇹", phoneCode: "+39" },
  { code: "JE", name: "Jersey", flag: "🇯🇪", phoneCode: "+44" },
  { code: "JM", name: "Jamaica", flag: "🇯🇲", phoneCode: "+1876" },
  { code: "JO", name: "Jordania", flag: "🇯🇴", phoneCode: "+962" },
  { code: "JP", name: "Japón", flag: "🇯🇵", phoneCode: "+81" },
  { code: "KE", name: "Kenia", flag: "🇰🇪", phoneCode: "+254" },
  { code: "KG", name: "Kirguistán", flag: "🇰🇬", phoneCode: "+996" },
  { code: "KH", name: "Camboya", flag: "🇰🇭", phoneCode: "+855" },
  { code: "KI", name: "Kiribati", flag: "🇰🇮", phoneCode: "+686" },
  { code: "KM", name: "Comoras", flag: "🇰🇲", phoneCode: "+269" },
  { code: "KN", name: "San Cristóbal y Nieves", flag: "🇰🇳", phoneCode: "+1869" },
  { code: "KP", name: "Corea del Norte", flag: "🇰🇵", phoneCode: "+850" },
  { code: "KR", name: "Corea del Sur", flag: "🇰🇷", phoneCode: "+82" },
  { code: "KW", name: "Kuwait", flag: "🇰🇼", phoneCode: "+965" },
  { code: "KY", name: "Islas Caimán", flag: "🇰🇾", phoneCode: "+1345" },
  { code: "KZ", name: "Kazajistán", flag: "🇰🇿", phoneCode: "+7" },
  { code: "LA", name: "Laos", flag: "🇱🇦", phoneCode: "+856" },
  { code: "LB", name: "Líbano", flag: "🇱🇧", phoneCode: "+961" },
  { code: "LC", name: "Santa Lucía", flag: "🇱🇨", phoneCode: "+1758" },
  { code: "LI", name: "Liechtenstein", flag: "🇱🇮", phoneCode: "+423" },
  { code: "LK", name: "Sri Lanka", flag: "🇱🇰", phoneCode: "+94" },
  { code: "LR", name: "Liberia", flag: "🇱🇷", phoneCode: "+231" },
  { code: "LS", name: "Lesoto", flag: "🇱🇸", phoneCode: "+266" },
  { code: "LT", name: "Lituania", flag: "🇱🇹", phoneCode: "+370" },
  { code: "LU", name: "Luxemburgo", flag: "🇱🇺", phoneCode: "+352" },
  { code: "LV", name: "Letonia", flag: "🇱🇻", phoneCode: "+371" },
  { code: "LY", name: "Libia", flag: "🇱🇾", phoneCode: "+218" },
  { code: "MA", name: "Marruecos", flag: "🇲🇦", phoneCode: "+212" },
  { code: "MC", name: "Mónaco", flag: "🇲🇨", phoneCode: "+377" },
  { code: "MD", name: "Moldavia", flag: "🇲🇩", phoneCode: "+373" },
  { code: "ME", name: "Montenegro", flag: "🇲🇪", phoneCode: "+382" },
  { code: "MF", name: "San Martín", flag: "🇲🇫", phoneCode: "+590" },
  { code: "MG", name: "Madagascar", flag: "🇲🇬", phoneCode: "+261" },
  { code: "MH", name: "Islas Marshall", flag: "🇲🇭", phoneCode: "+692" },
  { code: "MK", name: "Macedonia del Norte", flag: "🇲🇰", phoneCode: "+389" },
  { code: "ML", name: "Malí", flag: "🇲🇱", phoneCode: "+223" },
  { code: "MM", name: "Myanmar", flag: "🇲🇲", phoneCode: "+95" },
  { code: "MN", name: "Mongolia", flag: "🇲🇳", phoneCode: "+976" },
  { code: "MO", name: "Macao", flag: "🇲🇴", phoneCode: "+853" },
  { code: "MP", name: "Islas Marianas del Norte", flag: "🇲🇵", phoneCode: "+1670" },
  { code: "MQ", name: "Martinica", flag: "🇲🇶", phoneCode: "+596" },
  { code: "MR", name: "Mauritania", flag: "🇲🇷", phoneCode: "+222" },
  { code: "MS", name: "Montserrat", flag: "🇲🇸", phoneCode: "+1664" },
  { code: "MT", name: "Malta", flag: "🇲🇹", phoneCode: "+356" },
  { code: "MU", name: "Mauricio", flag: "🇲🇺", phoneCode: "+230" },
  { code: "MV", name: "Maldivas", flag: "🇲🇻", phoneCode: "+960" },
  { code: "MW", name: "Malaui", flag: "🇲🇼", phoneCode: "+265" },
  { code: "MX", name: "México", flag: "🇲🇽", phoneCode: "+52" },
  { code: "MY", name: "Malasia", flag: "🇲🇾", phoneCode: "+60" },
  { code: "MZ", name: "Mozambique", flag: "🇲🇿", phoneCode: "+258" },
  { code: "NA", name: "Namibia", flag: "🇳🇦", phoneCode: "+264" },
  { code: "NC", name: "Nueva Caledonia", flag: "🇳🇨", phoneCode: "+687" },
  { code: "NE", name: "Níger", flag: "🇳🇪", phoneCode: "+227" },
  { code: "NF", name: "Isla Norfolk", flag: "🇳🇫", phoneCode: "+672" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬", phoneCode: "+234" },
  { code: "NI", name: "Nicaragua", flag: "🇳🇮", phoneCode: "+505" },
  { code: "NL", name: "Países Bajos", flag: "🇳🇱", phoneCode: "+31" },
  { code: "NO", name: "Noruega", flag: "🇳🇴", phoneCode: "+47" },
  { code: "NP", name: "Nepal", flag: "🇳🇵", phoneCode: "+977" },
  { code: "NR", name: "Nauru", flag: "🇳🇷", phoneCode: "+674" },
  { code: "NU", name: "Niue", flag: "🇳🇺", phoneCode: "+683" },
  { code: "NZ", name: "Nueva Zelanda", flag: "🇳🇿", phoneCode: "+64" },
  { code: "OM", name: "Omán", flag: "🇴🇲", phoneCode: "+968" },
  { code: "PA", name: "Panamá", flag: "🇵🇦", phoneCode: "+507" },
  { code: "PE", name: "Perú", flag: "🇵🇪", phoneCode: "+51" },
  { code: "PF", name: "Polinesia Francesa", flag: "🇵🇫", phoneCode: "+689" },
  { code: "PG", name: "Papúa Nueva Guinea", flag: "🇵🇬", phoneCode: "+675" },
  { code: "PH", name: "Filipinas", flag: "🇵🇭", phoneCode: "+63" },
  { code: "PK", name: "Pakistán", flag: "🇵🇰", phoneCode: "+92" },
  { code: "PL", name: "Polonia", flag: "🇵🇱", phoneCode: "+48" },
  { code: "PM", name: "San Pedro y Miquelón", flag: "🇵🇲", phoneCode: "+508" },
  { code: "PN", name: "Islas Pitcairn", flag: "🇵🇳", phoneCode: "+64" },
  { code: "PR", name: "Puerto Rico", flag: "🇵🇷", phoneCode: "+1787" },
  { code: "PS", name: "Palestina", flag: "🇵🇸", phoneCode: "+970" },
  { code: "PT", name: "Portugal", flag: "🇵🇹", phoneCode: "+351" },
  { code: "PW", name: "Palaos", flag: "🇵🇼", phoneCode: "+680" },
  { code: "PY", name: "Paraguay", flag: "🇵🇾", phoneCode: "+595" },
  { code: "QA", name: "Catar", flag: "🇶🇦", phoneCode: "+974" },
  { code: "RE", name: "Reunión", flag: "🇷🇪", phoneCode: "+262" },
  { code: "RO", name: "Rumania", flag: "🇷🇴", phoneCode: "+40" },
  { code: "RS", name: "Serbia", flag: "🇷🇸", phoneCode: "+381" },
  { code: "RU", name: "Rusia", flag: "🇷🇺", phoneCode: "+7" },
  { code: "RW", name: "Ruanda", flag: "🇷🇼", phoneCode: "+250" },
  { code: "SA", name: "Arabia Saudí", flag: "🇸🇦", phoneCode: "+966" },
  { code: "SB", name: "Islas Salomón", flag: "🇸🇧", phoneCode: "+677" },
  { code: "SC", name: "Seychelles", flag: "🇸🇨", phoneCode: "+248" },
  { code: "SD", name: "Sudán", flag: "🇸🇩", phoneCode: "+249" },
  { code: "SE", name: "Suecia", flag: "🇸🇪", phoneCode: "+46" },
  { code: "SG", name: "Singapur", flag: "🇸🇬", phoneCode: "+65" },
  { code: "SH", name: "Santa Elena", flag: "🇸🇭", phoneCode: "+290" },
  { code: "SI", name: "Eslovenia", flag: "🇸🇮", phoneCode: "+386" },
  { code: "SJ", name: "Svalbard y Jan Mayen", flag: "🇸🇯", phoneCode: "+47" },
  { code: "SK", name: "Eslovaquia", flag: "🇸🇰", phoneCode: "+421" },
  { code: "SL", name: "Sierra Leona", flag: "🇸🇱", phoneCode: "+232" },
  { code: "SM", name: "San Marino", flag: "🇸🇲", phoneCode: "+378" },
  { code: "SN", name: "Senegal", flag: "🇸🇳", phoneCode: "+221" },
  { code: "SO", name: "Somalia", flag: "🇸🇴", phoneCode: "+252" },
  { code: "SR", name: "Surinam", flag: "🇸🇷", phoneCode: "+597" },
  { code: "SS", name: "Sudán del Sur", flag: "🇸🇸", phoneCode: "+211" },
  { code: "ST", name: "Santo Tomé y Príncipe", flag: "🇸🇹", phoneCode: "+239" },
  { code: "SV", name: "El Salvador", flag: "🇸🇻", phoneCode: "+503" },
  { code: "SX", name: "Sint Maarten", flag: "🇸🇽", phoneCode: "+1721" },
  { code: "SY", name: "Siria", flag: "🇸🇾", phoneCode: "+963" },
  { code: "SZ", name: "Esuatini", flag: "🇸🇿", phoneCode: "+268" },
  { code: "TC", name: "Islas Turcas y Caicos", flag: "🇹🇨", phoneCode: "+1649" },
  { code: "TD", name: "Chad", flag: "🇹🇩", phoneCode: "+235" },
  { code: "TF", name: "Territorios Australes Franceses", flag: "🇹🇫", phoneCode: "+262" },
  { code: "TG", name: "Togo", flag: "🇹🇬", phoneCode: "+228" },
  { code: "TH", name: "Tailandia", flag: "🇹🇭", phoneCode: "+66" },
  { code: "TJ", name: "Tayikistán", flag: "🇹🇯", phoneCode: "+992" },
  { code: "TK", name: "Tokelau", flag: "🇹🇰", phoneCode: "+690" },
  { code: "TL", name: "Timor Oriental", flag: "🇹🇱", phoneCode: "+670" },
  { code: "TM", name: "Turkmenistán", flag: "🇹🇲", phoneCode: "+993" },
  { code: "TN", name: "Túnez", flag: "🇹🇳", phoneCode: "+216" },
  { code: "TO", name: "Tonga", flag: "🇹🇴", phoneCode: "+676" },
  { code: "TR", name: "Turquía", flag: "🇹🇷", phoneCode: "+90" },
  { code: "TT", name: "Trinidad y Tobago", flag: "🇹🇹", phoneCode: "+1868" },
  { code: "TV", name: "Tuvalu", flag: "🇹🇻", phoneCode: "+688" },
  { code: "TW", name: "Taiwán", flag: "🇹🇼", phoneCode: "+886" },
  { code: "TZ", name: "Tanzania", flag: "🇹🇿", phoneCode: "+255" },
  { code: "UA", name: "Ucrania", flag: "🇺🇦", phoneCode: "+380" },
  { code: "UG", name: "Uganda", flag: "🇺🇬", phoneCode: "+256" },
  { code: "UM", name: "Islas Ultramarinas de EE.UU.", flag: "🇺🇲", phoneCode: "+1" },
  { code: "US", name: "Estados Unidos", flag: "🇺🇸", phoneCode: "+1" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾", phoneCode: "+598" },
  { code: "UZ", name: "Uzbekistán", flag: "🇺🇿", phoneCode: "+998" },
  { code: "VA", name: "Ciudad del Vaticano", flag: "🇻🇦", phoneCode: "+39" },
  { code: "VC", name: "San Vicente y las Granadinas", flag: "🇻🇨", phoneCode: "+1784" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪", phoneCode: "+58" },
  { code: "VG", name: "Islas Vírgenes Británicas", flag: "🇻🇬", phoneCode: "+1284" },
  { code: "VI", name: "Islas Vírgenes de EE.UU.", flag: "🇻🇮", phoneCode: "+1340" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳", phoneCode: "+84" },
  { code: "VU", name: "Vanuatu", flag: "🇻🇺", phoneCode: "+678" },
  { code: "WF", name: "Wallis y Futuna", flag: "🇼🇫", phoneCode: "+681" },
  { code: "WS", name: "Samoa", flag: "🇼🇸", phoneCode: "+685" },
  { code: "YE", name: "Yemen", flag: "🇾🇪", phoneCode: "+967" },
  { code: "YT", name: "Mayotte", flag: "🇾🇹", phoneCode: "+262" },
  { code: "ZA", name: "Sudáfrica", flag: "🇿🇦", phoneCode: "+27" },
  { code: "ZM", name: "Zambia", flag: "🇿🇲", phoneCode: "+260" },
  { code: "ZW", name: "Zimbabue", flag: "🇿🇼", phoneCode: "+263" }
];

// Función para buscar países por nombre o código
export const searchCountries = (query) => {
  if (!query) return countries;
  
  const searchTerm = query.toLowerCase();
  return countries.filter(country => 
    country.name.toLowerCase().includes(searchTerm) ||
    country.code.toLowerCase().includes(searchTerm) ||
    country.phoneCode.includes(searchTerm)
  );
};

// Función para obtener país por código
export const getCountryByCode = (code) => {
  return countries.find(country => country.code === code);
};

// Función para obtener país por código telefónico
export const getCountryByPhoneCode = (phoneCode) => {
  return countries.find(country => country.phoneCode === phoneCode);
};